module.exports = __webpack_public_path__ + "img/3.f4e6dc01.jpg";